import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ecdbe5ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h1--hero" }
const _hoisted_2 = { class: "hero-h-wrapper" }
const _hoisted_3 = {
  "data-w-id": "a57a7ba6-1456-df65-733e-c340ef917366",
  class: "h--super-large"
}
const _hoisted_4 = { class: "hero-h-wrapper" }
const _hoisted_5 = {
  "data-w-id": "201b457d-0993-bca7-76e5-88cdccd4a159",
  class: "h--super-large"
}
const _hoisted_6 = { class: "base--wrapper" }

import { DocumentLayout } from "@/layout";
import { ref, computed, onMounted, watch } from "vue";
import PrivacyPoliceEn from "@/locales/privacypolice/PrivacyPoliceEn.vue";
import PrivacyPoliceCz from "@/locales/privacypolice/PrivacyPoliceCz.vue";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyPolicy',
  setup(__props) {

// Импорты из Vue 3 Composition API

const { locale } = useI18n();
const curLang = ref("cz");
onMounted(async () => {
  curLang.value = localStorage.getItem("locale") || "cz";
  locale.value = curLang.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DocumentLayout), null, {
    default: _withCtx(() => [
      _createElementVNode("h1", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("privacyPolicy.Privacy")), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("privacyPolicy.Policy")), 1)
        ])
      ]),
      _createTextVNode(" " + _toDisplayString(_unref(locale)) + " ", 1),
      _createElementVNode("div", _hoisted_6, [
        (_unref(locale) === 'en')
          ? (_openBlock(), _createBlock(PrivacyPoliceEn, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(locale) === 'cz')
          ? (_openBlock(), _createBlock(PrivacyPoliceCz, { key: 1 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})